import React, { useEffect, useRef, useState } from "react";
import { HotTable, HotColumn } from "@handsontable/react";
import "handsontable/dist/handsontable.min.css";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { amountRenderer, contextMenu, firstRowRenderer, percentRenderer, sumColumnList, unitRenderer } from "../../../components/HandsonTable/handsontable";
import { ZeroToNull } from "../../../utilities/NullUtil";

export default function P231List({ dataTable, dataCol, keyListB, searchData, submitForm, setDialogReport }) {
    const hot = useRef(null);
    const history = useHistory();

    const [editRowList, setEditRowList] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [sumaryBot, setSumaryBot] = useState(0);
    const [readOnlyList, setReadOnlyList] = useState([]);
    const [routeLast, setRouteLast] = useState(0);
    const [updateList, setUpdateList] = useState([]);
    const [data, setData] = useState([]);

    const [mergeCells, setMergeCells] = useState([]);

    useEffect(() => {
        //keyListB
        if (dataTable.length > 0 && dataCol.length > 0) {
            HotSetting();
        }
    }, [dataTable, dataCol]);

    const HotSetting = () => {
        let newHdInfo = [
            {
                seqPk: "ที่",
                itemDesc: "รายการ",
                itemUnitDesc: "หน่วย",
                itemUnitPrice: "ราคาต่อหน่วย",
                contractUnit: "สัญญา",
                contractAmount: "",
                accrueUnit: "accrueUnit",
                updateKey: "key",
            },
            {
                seqPk: "",
                itemDesc: "",
                itemUnitDesc: "",
                itemUnitPrice: "",
                contractUnit: "จำนวน",
                contractAmount: "รวม",
                accrueUnit: "accrueUnit",
                updateKey: "key",
            },
        ];
        let newColumnList = ["seqPk", "itemDesc", "itemUnitDesc", "itemUnitPrice", "contractUnit", "contractAmount"];
        let newMergeCells = [
            { row: 0, col: 0, rowspan: 2, colspan: 1 },
            { row: 0, col: 1, rowspan: 2, colspan: 1 },
            { row: 0, col: 2, rowspan: 2, colspan: 1 },
            { row: 0, col: 3, rowspan: 2, colspan: 1 },
            { row: 0, col: 4, rowspan: 1, colspan: 2 },
        ];
        let newDataTable = [...dataTable];
        let newEditRowList = [];
        let sumaryBot = {
            seqPk: "",
            itemDesc: "TOTAL",
            itemUnitDesc: "",
            itemUnitPrice: "",
            contractUnit: "",
            contractAmount: "",
            accrueUnit: "",
            updateKey: "",
        };

        let sumaryRead = [];
        let conutMerge = 6;

        let newReadOnlyList = dataTable.map(() => []);
        newReadOnlyList.push([]);

        dataCol.forEach((obj) => {
            // const findIndex = dataTable.findIndex((item) => {
            //     return item.seqPk === obj.seq;
            // });

            const findIndex = (obj.seqPk - 1) % dataTable.length;

            if (findIndex > -1) {
                let newData = newDataTable[findIndex];

                // if(obj.inputFlag === 'Y'){
                //     SumColList.push(conutMerge-2)
                //     SumColList = duplicateList(SumColList)
                // }

                if (findIndex === 0) {
                    // newKeyList.push(newData.updateKey)
                    newColumnList.push(`deliverUnit_${obj.columnNo}`);
                    newColumnList.push(`deliverAmount_${obj.columnNo}`);
                    //Start Col - 8 AF.+2
                    newMergeCells.push({ row: 0, col: conutMerge, rowspan: 1, colspan: 2 });
                    newEditRowList.push(conutMerge);
                    conutMerge += 2;

                    sumaryRead.push("N");
                    sumaryRead.push("N");

                    if (obj.columnHeader === "ถึงครั้งนี้") {
                        setRouteLast(obj.columnNo);
                        // SumColList.push(conutMerge-2)
                        // SumColList = duplicateList(SumColList)
                    }

                    let newColHd = {
                        ...newHdInfo[0],
                        [`deliverUnit_${obj.columnNo}`]: obj.columnHeader,
                        [`deliverAmount_${obj.columnNo}`]: "",
                    };
                    newHdInfo[0] = newColHd;

                    newColHd = {
                        ...newHdInfo[1],
                        [`deliverUnit_${obj.columnNo}`]: "จำนวน",
                        [`deliverAmount_${obj.columnNo}`]: "รวม",
                    };
                    newHdInfo[1] = newColHd;

                    sumaryBot = {
                        ...sumaryBot,
                        [`deliverUnit_${obj.columnNo}`]: "",
                        [`deliverAmount_${obj.columnNo}`]: "",
                    };
                }

                newReadOnlyList[newData.seqPk].push(obj.inputFlag);
                newReadOnlyList[newData.seqPk].push("N");

                newData = {
                    ...newData,
                    // [`columnNo_${obj.columnNo}`]: obj.columnNo,
                    [`deliverUnit_${obj.columnNo}`]: ZeroToNull(obj.deliverUnit),
                    [`deliverAmount_${obj.columnNo}`]: ZeroToNull(obj.deliverAmount),
                };

                newDataTable[findIndex] = newData;
            }
        });
        for (let i = 4; i < newColumnList.length; i++) {
            // console.log(newColumnList[i]);
            let sum = sumColumnList(newDataTable, newColumnList[i]);
            sumaryBot = {
                ...sumaryBot,
                [`${newColumnList[i]}`]: sum,
            };
        }

        newDataTable.push(sumaryBot);
        newReadOnlyList.push(sumaryRead);
        setSumaryBot(newDataTable.length + 2);

        setData([...newHdInfo, ...newDataTable]);
        setColumnList(newColumnList);
        setMergeCells(newMergeCells);
        setReadOnlyList(newReadOnlyList);
        newEditRowList.pop();
        setEditRowList(newEditRowList);
    };

    const rendercolumns = () => {
        let columnData = [];
        columnList.forEach((item, index) => {
            if (index > 2) {
                columnData.push({
                    data: item,
                    type: "numeric",
                    numericFormat: {
                        pattern: "0,0",
                    },
                });
            } else {
                columnData.push({ data: item });
            }
        });
        return columnData;
    };

    const onAfterChange = (changes, source) => {
        if (!changes) {
            return;
        }
        //changes val
        let row = changes[0][0];
        let col = changes[0][1]; // Check to columnList index
        let oldVal = changes[0][2] === null || changes[0][2] === "" ? 0 : parseInt(changes[0][2]);
        let newVal = changes[0][3] === null || changes[0][3] === "" ? 0 : parseInt(changes[0][3]);
        let indexCol = columnList.findIndex((item) => item === col);

        if (editRowList.findIndex((item) => item === indexCol) > -1) {
            // KeyUpdate from keyListB
            let key = keyListB[row];

            //Get ref From HotTable
            let hotdata = hot.current.hotInstance;

            let indexUnitPrice = columnList.findIndex((item) => item === "itemUnitPrice");

            if (indexCol > -1) {
                let itemUnitPrice = hotdata.getDataAtCell(row, indexUnitPrice);
                let newAmountVal = newVal * itemUnitPrice;
                let deliverAmount = hotdata.getDataAtCell(row, indexCol + 1);
                hotdata.setDataAtCell(row, indexCol + 1, newAmountVal);

                // deliverAmount: null
                // deliverUnit: null
                if (routeLast && routeLast !== 0 && routeLast !== "") {
                    let deliverUnitIndex = columnList.findIndex((item) => item === `deliverUnit_${routeLast}`);
                    let deliverUnitAll = hotdata.getDataAtCell(row, deliverUnitIndex);
                    let deliverUnitAllNew = deliverUnitAll - oldVal + newVal;
                    hotdata.setDataAtCell(row, deliverUnitIndex, deliverUnitAllNew);

                    let deliverAmountAll = hotdata.getDataAtCell(row, deliverUnitIndex + 1);
                    let deliverAmountAllNew = deliverAmountAll - deliverAmount + newAmountVal;
                    hotdata.setDataAtCell(row, deliverUnitIndex + 1, deliverAmountAllNew);
                }

                onUpdateList(newVal, key);
            }
        }
    };

    const onUpdateList = (newVal, key) => {
        if (key) {
            let newUpdateList = [...updateList];
            newUpdateList.push({
                userId: searchData.userId,
                contractNo: searchData.contractNo,
                deliverNo: searchData.deliverNo,
                deliverUnit: newVal,
                routeNo: searchData.routeNo,
                updateKey: key,
            });

            setUpdateList(newUpdateList);
        }
    };

    const columnSummary = () => {
        if (hot.current && hot.current !== null) {
            let hotTable = hot.current.hotInstance;
            let sumRow = hotTable.countRows() - 1;

            let colSummaryArr = [];
            let countCols = hotTable.countCols();
            if (countCols > 0) {
                // sum would be for column 3 onwards
                for (let i = 2; i < countCols; i++) {
                    colSummaryArr.push({
                        destinationRow: sumRow,
                        destinationColumn: i,
                        // reversedRowCoords: true,
                        type: "sum",
                        ranges: [[2, sumRow - 1]],
                    });
                }
                return colSummaryArr;
            } else {
                return [];
            }
        } else {
            return [];
        }
    };

    const cells = (row, col) => {
        const cellProperties = {};
        //Set Coloer Table
        if (row === 0 || row === 1) {
            cellProperties.renderer = firstRowRenderer; //Header Table
        }
        // else{
        //     cellProperties.renderer = percentRenderer;
        // }

        if (row > 1) {
            if (col === 0 || col === 2) {
                cellProperties.className = " detail_center";
            } else {
                cellProperties.className = " detail";
            }
        }

        cellProperties.readOnly = true;
        // row -newReadOnlyList 1 == 2 row hot
        // col -newReadOnlyList 0 == 6 col hot

        if (row > 1 && col > 5) {
            // console.log("readOnlyList.length ", readOnlyList.length ,readOnlyList )
            if (readOnlyList && readOnlyList.length > 0 && row - 1 >= 0 && col - 6 >= 0) {
                // console.log('readOnlyList[row-1][col-6] ',row , col ,readOnlyList[row-1][col-6]);
                if (readOnlyList[row - 1][col - 6] !== undefined && readOnlyList[row - 1][col - 6] === "Y") {
                    cellProperties.readOnly = false;
                    cellProperties.className = " detail_input";
                }

                if (readOnlyList[readOnlyList.length - 1].length - 1 === col - 5) {
                    cellProperties.renderer = unitRenderer;
                }

                if (readOnlyList[readOnlyList.length - 1].length - 1 === col - 6) {
                    cellProperties.renderer = amountRenderer;
                }
            }
        }

        if (row === sumaryBot - 1) {
            cellProperties.readOnly = true;
            cellProperties.className = " summary_bot";
        }

        return cellProperties;
    };

    return (
        <div>
            {data.length > 0 ? (
                <HotTable
                    ref={hot}
                    data={data}
                    columns={rendercolumns()}
                    mergeCells={mergeCells}
                    autoRowSize={false}
                    autoColumnSize={true}
                    height={data.length > 50 ? "600px" : "300px"}
                    colWidths={[50, 400]}
                    contextMenu={contextMenu}
                    cells={(row, col) => cells(row, col)}
                    afterChange={(changes, source) => onAfterChange(changes, source)}
                    columnSummary={columnSummary}
                ></HotTable>
            ) : (
                ""
            )}
            <div className="p-col-12 p-md-12">
                <div className="p-grid" style={{ textAlign: "center" }}>
                    <div className="p-col-12">
                        <Button
                            className="p-button-success p-button btn-srh-responsive"
                            icon="pi pi-save"
                            label="บันทึก"
                            // style={{ marginLeft: '5px' }}
                            style={{ width: 120, marginLeft: "5px", marginTop: "10px" }}
                            onClick={() => submitForm(updateList, 231)}
                        />
                        <Button
                            className="p-button-secondary p-button btn-srh-responsive"
                            icon="pi pi-arrow-left"
                            label="กลับหน้าจอหลัก"
                            // style={{ marginLeft: '5px' }}
                            style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                            onClick={() =>
                                history.push({
                                    pathname: "230",
                                    state: {
                                        contractNo: searchData.contractNo,
                                        routeNo: searchData.routeNo,
                                        deliverNo: searchData.deliverNo,
                                    },
                                })
                            }
                        />
                        <Button
                            className="p-button btn-srh-responsive"
                            icon="pi pi-print"
                            style={{ marginLeft: 10, marginLeft: "5px", marginTop: "10px" }}
                            label="พิมพ์"
                            // style={{width:120}}
                            onClick={() => setDialogReport({ dialog: true, show: false })}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
